export const prices = [
  {
    _id: 0,
    name: 'Any',
    array: [],
  },
  {
    _id: 1,
    name: '₹ 0 to ₹ 1000',
    array: [0, 1000],
  },
  {
    _id: 2,
    name: 'Rs1000 to ₹ 5000',
    array: [1000, 5000],
  },
  {
    _id: 3,
    name: '₹ 5000 to ₹ 10000',
    array: [5000, 10000],
  },
  {
    _id: 4,
    name: '₹ 10000 to ₹ 15000',
    array: [10000, 15000],
  },
  {
    _id: 5,
    name: 'More than ₹ 15000',
    array: [15000, 1000000],
  },
];
